'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var TruncateComponents = require('../../../utils/TruncateComponents.js');
var classNames = require('classnames');
var AddressTableCellContent = require('./TableCellContent/AddressTableCellContent.js');
var AddressTextTableCellContent = require('./TableCellContent/AddressTextTableCellContent.js');
var CurrencyTableCellContent = require('./TableCellContent/CurrencyTableCellContent.js');
var DateTableCellContent = require('./TableCellContent/DateTableCellContent.js');
var ExpandableTableCell = require('./ExpandableTableCell.js');
var PhoneTableCellContent = require('./TableCellContent/PhoneTableCellContent.js');
var TextTableCellContent = require('./TableCellContent/TextTableCellContent.js');
var DateTimeTableCellContent = require('./TableCellContent/DateTimeTableCellContent.js');
var TableCell$1 = require('../../../node_modules/@material-ui/core/esm/TableCell/TableCell.js');
var Link = require('../../../node_modules/@material-ui/core/esm/Link/Link.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var VERTICAL_PADDING = 16;
var HORIZONTAL_PADDING = 8;
var useStyles = makeStyles["default"]({
  root: {},
  vertical: {
    paddingTop: VERTICAL_PADDING,
    paddingBottom: VERTICAL_PADDING
  },
  horizontal: {
    paddingLeft: HORIZONTAL_PADDING,
    paddingRight: HORIZONTAL_PADDING
  },
  both: {
    padding: "".concat(VERTICAL_PADDING, "px ").concat(HORIZONTAL_PADDING, "px")
  },
  top: {
    verticalAlign: 'top'
  },
  middle: {
    verticalAlign: 'middle'
  },
  bottom: {
    verticalAlign: 'bottom'
  },
  noPaddingCell: {
    padding: 0
  },
  link: {
    display: 'inline-block',
    width: '100%',
    height: '100%'
  },
  clickableCollapse: {
    height: ExpandableTableCell.TWO_ROW_HEIGHT + 2 * VERTICAL_PADDING,
    maxHeight: ExpandableTableCell.TWO_ROW_HEIGHT + 2 * VERTICAL_PADDING
  },
  allBorders: {
    border: '1px solid #e0e0e0'
  },
  noBorders: {
    borderStyle: 'hidden'
  },
  verticalBorders: {
    borderStyle: 'solid',
    borderLeftWidth: '1px',
    borderTopStyle: 'hidden',
    borderBottomStyle: 'hidden',
    borderRightWidth: '1px',
    borderColor: '#e0e0e0'
  },
  horizontalBorders: {
    borderStyle: 'solid',
    borderLeftStyle: 'hidden',
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderRightStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  exterior: {
    border: '0px solid #e0e0e0'
  },
  rightTopBorders: {
    borderStyle: 'solid',
    borderTopWidth: '1px',
    borderBottomStyle: 'hidden',
    borderRightWidth: '1px',
    borderLeftStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  onlyRightBorder: {
    borderStyle: 'solid',
    borderRightWidth: '1px',
    borderTopStyle: 'hidden',
    borderBottomStyle: 'hidden',
    borderLeftStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  onlyTopBorder: {
    borderStyle: 'solid',
    borderLeftStyle: 'hidden',
    borderTopWidth: '1px',
    borderBottomStyle: 'hidden',
    borderRightStyle: 'hidden',
    borderColor: '#e0e0e0'
  }
});
var CUSTOM_PADDING_OPTIONS = ['vertical', 'horizontal', 'both'];

var TableCell = function TableCell(_ref) {
  var _wrapperProps;

  var variant = _ref.variant,
      expanded = _ref.expanded,
      className = _ref.className,
      children = _ref.children,
      dependencies = _ref.dependencies,
      truncate = _ref.truncate,
      maxLines = _ref.maxLines,
      padding = _ref.padding,
      verticalAlign = _ref.verticalAlign,
      href = _ref.href,
      target = _ref.target,
      borders = _ref.borders,
      stickyColumn = _ref.stickyColumn,
      wordBreak = _ref.wordBreak,
      copyable = _ref.copyable,
      props = objectWithoutProperties(_ref, ["variant", "expanded", "className", "children", "dependencies", "truncate", "maxLines", "padding", "verticalAlign", "href", "target", "borders", "stickyColumn", "wordBreak", "copyable"]);

  var styles = useStyles();
  var root = styles.root,
      noPaddingCell = styles.noPaddingCell,
      link = styles.link,
      clickableCollapse = styles.clickableCollapse;
  var appliedBorders = null;

  switch (borders) {
    case 'all':
      appliedBorders = stickyColumn ? styles.rightTopBorders : styles.allBorders;
      break;

    case 'interior':
      appliedBorders = stickyColumn ? styles.rightTopBorders : styles.allBorders;
      break;

    case 'exterior':
      appliedBorders = styles.exterior;
      break;

    case 'none':
      appliedBorders = styles.noBorders;
      break;

    case 'noOuterVertical':
      appliedBorders = stickyColumn ? styles.rightTopBorders : styles.allBorders;
      break;

    case 'noOuterHorizontal':
      appliedBorders = stickyColumn ? styles.rightTopBorders : styles.allBorders;
      break;

    case 'onlyVertical':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.verticalBorders;
      break;

    case 'onlyHorizontal':
      appliedBorders = stickyColumn ? styles.onlyTopBorder : styles.horizontalBorders;
      break;

    case 'onlyInteriorVertical':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.verticalBorders;
      break;

    case 'onlyInteriorHorizontal':
      appliedBorders = stickyColumn ? styles.onlyTopBorder : styles.horizontalBorders;
      break;

    case 'onlyOuterRight':
      appliedBorders = styles.exterior;
      break;

    case 'onlyOuterLeft':
      appliedBorders = styles.exterior;
      break;

    case 'onlyOuterTop':
      appliedBorders = styles.exterior;
      break;

    case 'onlyOuterBottom':
      appliedBorders = styles.exterior;
      break;
  }

  var appliedClass = classNames__default["default"](styles[verticalAlign], root, defineProperty({}, appliedBorders, !!borders), className);
  var cellPadding = padding;

  if (CUSTOM_PADDING_OPTIONS.indexOf(padding) >= 0) {
    cellPadding = 'default';
    appliedClass = classNames__default["default"](styles[padding], appliedClass);
  }

  var wrapperComponent = 'div';
  var wrapperProps;

  if (href) {
    appliedClass = classNames__default["default"](appliedClass, noPaddingCell);
    wrapperComponent = Link["default"];
    wrapperProps = {
      href: href,
      target: target,
      rel: target ? 'noopener' : undefined,
      underline: 'none',
      color: 'textPrimary',
      className: classNames__default["default"](link, styles[padding])
    };
  }

  var expansionProps = {
    className: classNames__default["default"](defineProperty({}, clickableCollapse, !!href && !expanded))
  };

  switch (variant) {
    case 'address':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(AddressTableCellContent, {
        wrapperComponent: wrapperComponent,
        wrapperProps: wrapperProps,
        truncate: truncate,
        maxLines: 1,
        dependencies: dependencies
      }, children));

    case 'address-text':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(AddressTextTableCellContent, {
        wrapperComponent: wrapperComponent,
        wrapperProps: wrapperProps,
        truncate: truncate,
        maxLines: 1,
        dependencies: dependencies,
        copyable: copyable
      }, children));

    case 'currency':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(CurrencyTableCellContent, {
        wrapperComponent: wrapperComponent,
        wrapperProps: wrapperProps
      }, children));

    case 'phone':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(PhoneTableCellContent, {
        wrapperComponent: wrapperComponent,
        wrapperProps: wrapperProps,
        truncate: truncate,
        maxLines: maxLines,
        dependencies: dependencies,
        copyable: copyable
      }, children));

    case 'date':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(DateTableCellContent, {
        wrapperComponent: wrapperComponent,
        wrapperProps: wrapperProps
      }, children));

    case 'datetime':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(DateTimeTableCellContent, {
        wrapperComponent: wrapperComponent,
        wrapperProps: wrapperProps
      }, children));

    case 'tags':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(TruncateComponents, _objectSpread({
        wrapperComponent: wrapperComponent,
        truncate: truncate,
        dependencies: dependencies
      }, wrapperProps), children));

    case 'text':
      return React__default["default"].createElement(ExpandableTableCell["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding,
        expanded: expanded,
        expansionProps: expansionProps
      }, props), React__default["default"].createElement(TextTableCellContent, {
        wrapperComponent: wrapperComponent,
        wrapperProps: wrapperProps,
        truncate: truncate,
        maxLines: maxLines,
        dependencies: dependencies,
        color: props.color,
        wordBreak: wordBreak,
        copyable: copyable
      }, children));

    default:
      var Wrapper = wrapperComponent;
      wrapperProps = _objectSpread({}, wrapperProps, {
        className: classNames__default["default"]((_wrapperProps = wrapperProps) === null || _wrapperProps === void 0 ? void 0 : _wrapperProps.className, expansionProps.className)
      });
      return React__default["default"].createElement(TableCell$1["default"], _objectSpread({
        className: appliedClass,
        padding: cellPadding
      }, props), React__default["default"].createElement(Wrapper, _objectSpread({}, wrapperProps), children || React__default["default"].createElement("div", null)));
  }
};

TableCell.defaultProps = {
  variant: null,
  expanded: false,
  padding: 'both',
  verticalAlign: 'top',
  truncate: false,
  wordBreak: 'normal',
  copyable: false
};

module.exports = TableCell;
